<div *ngIf="role" class="row">
  <div class="col-md-12">
    <form class="form-validation">
      <!-- Only on new -->
      <div *ngIf="!role.id" class="row my-3 fields-group py-2">
        <div class="col-12">
          <label class="input-label hidden">{{ 'roles.type' | translate }}:&nbsp;</label>
          <input name="options" type="radio" [checked]="role.type == 'UserRole'" (change)="role.type = 'UserRole'"
            [value]="true" class="ml-0" />&nbsp;{{ 'roles.user_role' | translate }}
          <input name="options" type="radio" [checked]="role.type == 'BotRole'" (change)="role.type = 'BotRole'"
            [value]="false" class="ml-3" />&nbsp;{{ 'roles.bot_role' | translate }}
          <i class="ml-5 fas {{role.startRole ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
            (click)="role.startRole = !role.startRole" style="margin-inline-end:0.5rem;position:relative;top:2px"></i>
          <label class="input-label"> {{ 'roles.start_role' | translate }}</label>
        </div>
      </div>
      <div *ngIf="!role.id" class="row fields-group" [hidden]="!role || role.type != 'UserRole'">
        <div class="col-6 pr-0">
          <label class="input-label field-required">{{ 'roles.operator_type' | translate }}</label>
          <select [(ngModel)]="role.assignedTo" class="form-control" name="assignedTo" #assignedTo="ngModel" required>
            <option selected disabled hidden style="display: none" value=""></option>
            <!--<option value="simple">{{ 'role.simple' | translate }}</option>-->
            <option value="processing">{{ 'role.processing' | translate }}</option>
            <option value="applicantPayment">{{ 'role.applicantPayment' | translate }}</option>
            <!--<option value="treasury">{{ 'role.treasury' | translate }}</option>-->
            <!--<option value="collection">{{ 'role.collection' | translate }}</option>-->
            <option value="applicant">{{ 'role.applicant' | translate }}</option>
            <option value="revision">{{ 'role.revision' | translate }}</option>
          </select>
          <p class="validation-error" *ngIf="assignedTo?.touched && assignedTo.errors?.required">{{
            'form.validate.required' | translate }}</p>
        </div>
      </div>
      <div class="row">
        <!-- Edit & new from here -->
        <div class="col-12">
          <div class="row mb-4 det-row pr-3 fields-group">
            <div class="col-8">
              <div class="list-title d-flex w-100">
                <span class="field-required">
                  {{ 'roles.name' | translate }}
                </span>
                <span class="ml-auto text-right toggle">
                  {{ 'roles.visibleForApplicant' | translate }}
                  <i class="ml-2 toggle-label fas {{role.visibleForApplicant ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                    (click)="role.visibleForApplicant = !role.visibleForApplicant;saveRole();"></i>
                </span>
                <div *ngIf="role.id" class="col-auto p-0" (click)="openDetEdit();$event.stopPropagation();">
                  <det-popover [extraClasses]="hasDeterminant(role) ? 'active' : ''"
                    [determinant]="role.jsonDeterminants" [hasErrors]="hasError(role.jsonDeterminants)" [placement]="'top'"
                    [determinantMapById]="determinantMapById"></det-popover>
                </div>
              </div>
              <form class="form-controller">
                <div class="w-100" *ngIf="showRoleAdd">
                  <input class="form-control" type="text" name="roleName" [(ngModel)]="role.name"
                    [rangeLength]="[2, 256]" #fname="ngModel" placeholder="{{ 'Type a role name' | translate }}"
                    (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event);$event.stopPropagation()"
                    (input)="nameChanged($event.target.value)" required [disabled]="loading" />
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.required && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.required' | translate }}
                  </p>
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.minLenght' | translate }} 2!
                  </p>
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.maxLenght' | translate }} 256!
                  </p>
                </div>
                <div class="w-100" *ngIf="!showRoleAdd">
                  <input class="form-control" type="text" name="roleName" [(ngModel)]="role.name" #fname="ngModel"
                    [rangeLength]="[2, 256]" placeholder="{{ 'Type a role name' | translate }}"
                    (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event);$event.stopPropagation()" required
                    [disabled]="loading" />
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.required && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.required' | translate }}
                  </p>
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.minLenght' | translate }} 2!
                  </p>
                  <p class="validation-error"
                    *ngIf="fname && fname.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                    {{ 'form.validate.maxLenght' | translate }} 256!
                  </p>
                </div>
              </form>
            </div>
            <div class="col-4">
              <div class="list-title mr-3 mr-md-0">
                <span class="field-required">
                  {{ 'roles.short_name' | translate }}
                </span>
              </div>
              <form class="form-controller">
                <input required class="form-control" type="text" name="roleShortName" [(ngModel)]="role.shortName"
                  [rangeLength]="[2, 20]" #sname="ngModel" (focus)="startEdit($event)"
                  (focusout)="submitEditOnFocus($event);$event.stopPropagation()" maxlength="20" [disabled]="loading" />
              </form>
              <p class="validation-error" *ngIf="sname && sname.errors?.required && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.required' | translate }}
              </p>
              <p class="validation-error"
                *ngIf="sname && sname.errors?.rangeLength && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.minLenght' | translate }} 2!
              </p>
              <p class="validation-error"
                *ngIf="sname && sname.errors?.rangeLength && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.maxLenght' | translate }} 20!
              </p>
            </div>
          </div>

          <div *ngIf="role.type == 'BotRole'" class="row mb-4 fields-group py-2">
            <div class="col">
              <div class="row">
                <div class="col">
                  <i class="fas {{role.repeatUntilSuccessful ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                    (click)="role.repeatUntilSuccessful = !role.repeatUntilSuccessful;saveRole()"
                    style="margin-inline-end:0.5rem;position:relative;top:2px"></i>
                  <label class="input-label"> {{ 'roles.repeat_until_successful' | translate }}</label>
                </div>
              </div>
              <div *ngIf="role.repeatUntilSuccessful" class="row mt-2">
                <div class="col">
                  <table class="over-colored-bg mb-2">
                    <thead class="thead-inverse">
                      <tr>
                        <th class="text-left field-required" colspan="3">
                          {{'roles.repeatIn' | translate}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.repeatInMinutes && !role.repeatInHours && !role.repeatInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="repeatInMinutes"
                              [(ngModel)]="role.repeatInMinutes" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.minutes' | translate}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.repeatInMinutes && !role.repeatInHours && !role.repeatInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="repeatInHours"
                              [(ngModel)]="role.repeatInHours" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.hours' | translate}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.repeatInMinutes && !role.repeatInHours && !role.repeatInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="repeatInDays"
                              [(ngModel)]="role.repeatInDays" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.days' | translate}}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="role.repeatUntilSuccessful" class="row">
                <div class="col">
                  <table class="over-colored-bg mb-0">
                    <thead class="thead-inverse">
                      <tr>
                        <th class="text-left field-required" colspan="3">
                          {{'roles.duration' | translate}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.durationInMinutes && !role.durationInHours && !role.durationInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="durationInMinutes"
                              [(ngModel)]="role.durationInMinutes" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.minutes' | translate}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.durationInMinutes && !role.durationInHours && !role.durationInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="durationInHours"
                              [(ngModel)]="role.durationInHours" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.hours' | translate}}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            class="input-group input-group-sm {{ !role.durationInMinutes && !role.durationInHours && !role.durationInDays ? 'is-invalid' : ''}}">
                            <input class="form-control" type="number" name="durationInDays"
                              [(ngModel)]="role.durationInDays" (focus)="startEdit($event)"
                              (focusout)="submitEmptyEditOnFocus($event);$event.stopPropagation()" [disabled]="loading">
                            <div class="input-group-append">
                              <span class="input-group-text" id="basic-addon1">{{'roles.days' | translate}}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="role.id && registrations" class="row mb-4 fields-group faded no-filter">
            <div class="col">
              <registrations-role (refreshRegistrations)="notifyRoleChange()"
                [registrations]="registrations"></registrations-role>
            </div>
          </div>
          <div *ngIf="role.id && !isForApplicant()" class="row mb-4 fields-group faded no-filter">
            <institution-role class="col" *ngIf="roleInstitutionsLength > -1 && institutions?.length" [role]="role"
              [mandatory]="true" [institutions]="institutions" [roleInstitutions]="roleInstitutions"
              (roleInstitutionsLength)="updateRoleInstitutionsLength($event);"></institution-role>
            <unit-role class="col pr-0" *ngIf="roleInstitutionsLength > 0" [role]="role"
              [roleInstitutions]="roleInstitutions" (roleUnitsLength)="updateRoleUnitsLength($event);"></unit-role>
            <determinant-institution class="col-auto p-0" *ngIf="roleInstitutionsLength > 0"
              (selectInstitution)="setInsitution($event)" [roleInstitutions]="roleInstitutions" [role]="role"
              [determinantMapById]="determinantMapById" [debugErrors]="debugErrors"></determinant-institution>
          </div>
          <div class="row fields-group">
            <div class="col-12 col-md-6 pr-md-0">
              <label class="list-title">{{ 'roles.section_description' | translate }}</label>
              <textarea name="description" [(ngModel)]="role.description" class="form-control oneline-textarea"
                (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event);$event.stopPropagation()" rows=2
                #desc="ngModel" [rangeLength]="[0, 256]"></textarea>
              <p class="validation-error" *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }}
                256!</p>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>